// Libraries
import styled from "styled-components";

export const SvgIconContainer = styled.div`
  display: flex;
  svg {
    width: ${(props) => (props.size ? props.size : null)};
    height: auto;
    fill: ${(props) => (props.color ? props.color : null)};

    path {
      fill: ${(props) => (props.color ? props.color : null)};
    }
  }
`;
